import { PickerTitle } from '@entities/period-picker/model/picker-title.enum';
import { TPickerData } from '@features/CalendarPeriodPicker/model/types';

export const pickersData: TPickerData = [
    {
        id: PickerTitle.CHOOSE_PERIOD,
        title: i18next.t('PeriodPicker.ChoosePeriod'),
    },
    // {
    //     id: PickerTitle.CURRENT_WEEK,
    //     title: i18next.t('PeriodPicker.CurrentWeek'),
    // },
    {
        id: PickerTitle.PREVIOUS_SEVEN_DAYS,
        title: i18next.t('PeriodPicker.PreviousSevenDays'),
    },
    {
        id: PickerTitle.PREVIOUS_WEEK,
        title: i18next.t('PeriodPicker.PreviousWeek'),
    },
    {
        id: PickerTitle.CURRENT_MONTH,
        title: i18next.t('PeriodPicker.CurrentMonth'),
    },
    {
        id: PickerTitle.PREVIOUS_MONTH,
        title: i18next.t('PeriodPicker.PreviousMonth'),
    },
    {
        id: PickerTitle.CURRENT_QUARTER,
        title: i18next.t('PeriodPicker.CurrentQuarter'),
    },
];

export const pickerDataLessThen1500: TPickerData = [
    {
        id: PickerTitle.CHOOSE_PERIOD,
        title: i18next.t('PeriodPicker.ChoosePeriod'),
    },
    {
        id: PickerTitle.PREVIOUS_SEVEN_DAYS,
        title: i18next.t('PeriodPicker.PreviousSevenDays.LessThen1500'),
    },
    {
        id: PickerTitle.CURRENT_MONTH,
        title: i18next.t('PeriodPicker.CurrentMonth.LessThen1500'),
    },
    {
        id: PickerTitle.CURRENT_QUARTER,
        title: i18next.t('PeriodPicker.CurrentQuarter.LessThen1500'),
    },
];
